import React from 'react';
import $ from 'jquery';
import { OTHER_CONTENT } from '../../../../constants/Labels';
import { parseToFloat } from '../../../../helpers/tools';

class ContentDataSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'content';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
  }

  componentDidMount() {
    this.toggleBlurListeners(true);
  }

  componentWillUnmount() {
    this.toggleBlurListeners(false);
  }

  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }

  toggleBlurListeners = addListeners => {
    if (addListeners) {
      $('#' + this.section)
        .find('input[name="sas_contentid"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'string', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="sas_videoContentDuration"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', false, this);
          }).bind(this)
        );
    } else {
      $('#' + this.section)
        .find('input[name="sas_contentid"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="sas_videoContentDuration"]')
        .off('blur');
    }
  };

  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div className="placementDescription">
          <div className="pluginSectionsTitle">Content Data Settings</div>
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: OTHER_CONTENT }}
          ></div>
        </div>
        <div className="settingsInputs">
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Content ID</label>
              </div>
              <div className="smallInput">
                <label>Content duration</label>
              </div>
            </div>
            <div className="smallInput">
              <input
                type="text"
                name="sas_contentid"
                className="textFiled"
                defaultValue={this.props.content.sas_contentid}
                key={this.props.content.sas_contentid}
              />
              <div className="validationError"></div>
            </div>
            <div className="smallInput">
              <input
                type="number"
                name="sas_videoContentDuration"
                className="textFiled"
                defaultValue={this.props.content.sas_videoContentDuration}
                key={this.props.content.sas_videoContentDuration}
              />
              <div className="validationError"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContentDataSettings;
